import React, { useEffect, useRef } from "react";
import { ShieldCheck, CheckCircle, Zap, Rocket, Sparkles, Brain } from "lucide-react";
import "./leadhero.css";

export default function Leadhero() {
  const carouselRef = useRef(null);

  useEffect(() => {
    const carousel = carouselRef.current;
    let scrollAmount = 0;

    const autoScroll = () => {
      if (!carousel) return;
      scrollAmount += 2;
      carousel.scrollLeft = scrollAmount;

      if (scrollAmount >= carousel.scrollWidth - carousel.clientWidth) {
        scrollAmount = 0;
      }
    };

    const interval = setInterval(autoScroll, 30);
    return () => clearInterval(interval);
  }, []);

  const slides = [
    {
      title: " Leads Delivered to WhatsApp",
      desc: "AI-verified buyers delivered directly to WhatsApp.",
      icon: <ShieldCheck className="w-14 h-14 text-rose-300 drop-shadow-xl" />,
      gradient: "from-rose-600/40 to-rose-400/20",
    },
    {
      title: "Verified Customers Only",
      desc: "Every lead goes through phone verification + fraud check.",
      icon: <CheckCircle className="w-14 h-14 text-emerald-300 drop-shadow-xl" />,
      gradient: "from-emerald-600/40 to-emerald-400/20",
    },
    {
      title: "AI Growth Autopilot",
      desc: "AI handles ranking, ads, branding & conversations.",
      icon: <Brain className="w-14 h-14 text-indigo-300 drop-shadow-xl" />,
      gradient: "from-indigo-600/40 to-indigo-400/20",
    },
    {
      title: "Smart Buyer Prediction",
      desc: "AI predicts which customer will buy.",
      icon: <Rocket className="w-14 h-14 text-yellow-300 drop-shadow-xl" />,
      gradient: "from-yellow-600/40 to-yellow-400/20",
    },
    {
      title: "Hyperlocal Target Boost",
      desc: "Scans competitors & boosts your local visibility.",
      icon: <Zap className="w-14 h-14 text-cyan-300 drop-shadow-xl" />,
      gradient: "from-cyan-600/40 to-cyan-400/20",
    },
  ];

  return (
    <section className="hero-section">
      <FloatingAIBackground />

      <div className="hero-title-box">
        <h1 className="hero-title">
          Grow Your Business <span className="highlight">10X Faster</span> With AI
        </h1>

        <p className="hero-subtitle">
          MarketMind4U is the world's first AI-powered business engine that gives you leads,
          verified customers, automated marketing & deep analytics.
        </p>
      </div>

      {/* AUTO CAROUSEL */}
      <div className="carousel-container">
        <div ref={carouselRef} className="carousel">
          {slides.concat(slides).map((slide, index) => (
            <div key={index} className="slide-card">
              <div className={`card-gradient ${slide.gradient}`} />
              <div className="card-content">
                {slide.icon}
                <h3 className="card-title">{slide.title}</h3>
                <p className="card-desc">{slide.desc}</p>
              </div>
            </div>
          ))}
        </div>
      </div>

      {/* GUARANTEE BOX */}
      <div className="guarantee-box">
        <Sparkles className="guarantee-icon" />

        <h2 className="guarantee-title">
        Lead Support Program
        </h2>

        <p className="guarantee-desc">
        We actively monitor, verify and optimize lead quality so you get
        real buyer enquiries with consistent performance.
        </p>

        <button className="cta-btn">
          Claim Your First Guaranteed Lead →
        </button>
      </div>
    </section>
  );
}

function FloatingAIBackground() {
  return (
    <div className="ai-bg">
      <div className="float-1" />
      <div className="float-2" />
      <div className="float-3" />
    </div>
  );
}
